import { JsonRPCService } from 'gw-portals-transport-js';
import { getProxiedServiceUrl } from 'gw-portals-url-js';

function retrieveQuote(id, selectedAddons, productType, brandcode) {
    return JsonRPCService.send(getProxiedServiceUrl('quote'), 'aggregatorRetrieve_Ext', [id, productType, selectedAddons, brandcode], {});
}

function getAggDetails(id, productType) {
    return JsonRPCService.send(getProxiedServiceUrl('quote'), 'getAggDetails_Ext', [id, productType], {});
}

export default {
    retrieveQuote,
    getAggDetails,
};
